﻿/* global require */
// depends-on: jQuery
// Eightfold Way twitter timeline fetch
(function ($) {
    var moment = require('moment-twitter'),
        _ = require('lodash');
    $.fn.efw$twittertimeline = function (options) {
        var opts = jQuery.extend({}, $.fn.efw$twittertimeline.defaults, options);

        // replace links with display-versions
        const _linkify = function (tweet, substits) {
            let has_quote = tweet.quoted_status_permalink && tweet.quoted_status_permalink.url;
            _.each(tweet.entities.urls, function (val) {
                // if this link is the quoted tweet, we'll empty it in the main tweet body
                let is_quote = (has_quote === val.url);
                let l = (is_quote ? '' : '<a target="_blank" class="tweet-link" href="' + val.expanded_url + '">' + val.display_url + '</a>'),
                    substit = { sub: l, start: val.indices[0], end: val.indices[1] };
                substits.push(substit);
            });
        }; 

        // replace images
        const _imagify = function (tweet, substits) {
            _.each(tweet.entities.media, function (val) {
                if (val.type == 'photo') {
                    let l = '<div class="tweet-media"><a target="_blank" href="' + val.expanded_url + '"><img src="' + val.media_url_https + '" alt="View image on Twitter" /></a></div>',
                        substit = { sub: l, start: val.indices[0], end: val.indices[1] };
                    substits.push(substit);
                }
            });
            //if (tweet.extended_entities) {
            //    console.log('Extended entities: ' + JSON.stringify(tweet.extended_entities));
            //}
        };

        // replace @mentions with display-versions
        const _atify = function (tweet, substits) {
            _.each(tweet.entities.user_mentions, function (val) {
                let l = '<a target="_blank" class="tweet-at" href="https://twitter.com/' + val.screen_name + '">@' + val.screen_name + '</a>',
                    substit = { sub: l, start: val.indices[0], end: val.indices[1] };
                substits.push(substit);
            });
        }; 

        // replace #hashtags with display-versions
        const _hashify = function (tweet, substits) {
            _.each(tweet.entities.hashtags, function (val) {
                let l = '<a target="_blank" class="tweet-hash" href="https://twitter.com/hashtag/' + val.text + '?src=hashtag_click">#' + val.text + '</a>',
                    substit = { sub: l, start: val.indices[0], end: val.indices[1] };
                substits.push(substit);
            });
        };

        const _videoify = function (tweet) {
            //console.log('_videoify');

            var s = '';

            // notice YouTube video references, and embed them.
            if (tweet.entities.media && tweet.entities.media.length > 0) {
                //console.log('defer to media');
                return s;  // assume the media pass has already handled it.
            }

            _.each(tweet.entities.urls, function (url) {
                // - Supported YouTube URL formats:
                //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
                //   - http://youtu.be/My2FRPA3Gf8
                //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
                // - Supported Vimeo URL formats:
                //   - http://vimeo.com/25451551
                //   - http://player.vimeo.com/video/25451551
                // - Also supports relative URLs:
                //   - //player.vimeo.com/video/25451551

                var x = url.expanded_url,
                    src,
                    opt;
                //console.log('parsing ' + x);
                if (x.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/)) {
                    if (RegExp.$3.indexOf('youtu') > -1) {
                        src = 'https://www.youtube.com/embed/';
                        opt = 'allowfullscreen';
                    } else if (RegExp.$3.indexof('vimeo') > -1) {
                        src = 'https://player.vimeo.com/video/';
                        opt = 'webkitAllowFullScreen mozallowfullscreen allowFullScreen';
                    }

                    if (src) {
                        s = `<div class="tweet-video"><iframe src="${src + RegExp.$6}" frameborder="0" ${opt}></iframe></div>`;
                    }
                    //console.log('s is ' + s);
                }
            });

            return s;
        };

        const _breakify = function (tweet) {
            return tweet.full_text.replace(/\n/g, '<br />');
        };

        const _replaceBetween = function (origin, startIndex, endIndex, insertion) {
            return origin.substring(0, startIndex) + insertion + origin.substring(endIndex);
        };

        const _prepare = function (tweet) {
            let substits = [];  // array of { sub, start, end }
            _linkify(tweet, substits);
            _imagify(tweet, substits);
            _atify(tweet, substits);
            _hashify(tweet, substits);

            // apply subsitutions to tweet.full_text
            // 1) Sort the substitutions by starting index and reverse.
            substits = _.reverse(_.sortBy(substits, ['start']));
            // 2) Apply those substitutions in reverse order (so as not to mangle the indices)
            _.each(substits, function (substit) {
                // substit = { sub, start, end }
                tweet.full_text = _replaceBetween(tweet.full_text, substit.start, substit.end, substit.sub);
            });

            tweet.full_text = _breakify(tweet);

            tweet.full_text += _videoify(tweet);

            return tweet.full_text;
        }

        const _time = function (t) {
            let m = moment(new Date(t)).twitter(); // nonstandard Twitter datestamp https://stackoverflow.com/questions/2611415/parsing-twitter-api-datestamp
            // fix formatting in Spanish.
            if ($('body').is('.l_2')) {
                //console.log("replacing " + m);
                m = m.replace(/^(\d+)\/(\d+)\/(\d+)$/, '$2/$1/$3');
                //console.log("...with " + m);
            }
            return m;
        };

        const _formatOneTweet = function (t, quoted) {
            var thisTweet = t,
                retweet = !!thisTweet.retweeted_status,
                tweet = (retweet ? thisTweet.retweeted_status : thisTweet),
                quotedTweet = (quoted ? null : tweet.quoted_status);

            var $wrap = $('<div class="tweet-wrapper" id="' + thisTweet.id_str + '"></div>');
            var $header = $('<div class="tweet-header"></div>');

            if (retweet) {
                var $retweetHeader = $('<div class="retweet-header"><a class="retweet-header-link" title="View on Twitter" href="' + 'https://twitter.com/' + tweet.user.screen_name + '/status/' + tweet.id_str + '"><span class="retweet"><span class="retweet-icon" title="Retweet"></span>' + thisTweet.user.name + ' ' + 'twitter.retweeted'._local() + '</span></a></div>');
                $header.append($retweetHeader);
            }
            var $author = $('<div class="tweet-attribution"><div class="tweet-avatar"><img class="tweet-avatar-image" src="' + tweet.user.profile_image_url_https + '" alt="" /></div><div class="tweet-user"><div class="tweet-author">' + tweet.user.name + '</div><div class="tweet-screenname"><a href="https://twitter.com/' + tweet.user.screen_name + '" target="_blank">' + '@' + tweet.user.screen_name + '</a></div></div>');
            $header.append($author);

            var $body = $('<div class="tweet-body">' + _prepare(tweet) + '</div>')

            if (quotedTweet) {
                var quotedUrl = (t.quoted_status_permalink && t.quoted_status_permalink.url ? t.quoted_status_permalink.url : '');
                var $quoted = $('<div class="tweet-quoted"></div>').attr('data-href', quotedUrl);
                $quoted.append(_formatOneTweet(quotedTweet, true)); // avoid recursion
                $body.append($quoted);
            }

            var $footer = $('<div class="tweet-footer"></div>');
            var $footerInner = $('<div class="tweet-footer-inner"></div>');

            var $social = $('<div class="tweet-social"></div>');
            var $like = $('<div class="tweet-like"><a target="_blank" href="https://twitter.com/intent/like?tweet_id=' + tweet.id_str + '" title="' + 'twitter.like'._local() + '"><span class="like-icon"></span></div>');
            var $shareWrapper = $('<div class="tweet-share dropdown"></div>');
            var $share = $('<button class="image-button border-link" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" href="javascript:void(0)" title="' + 'twitter.share'._local() + '" ><img src="/master_images/3/play.svg" alt="" /></button>');
            var $shareMenu = $('<div class="dropdown-menu"><a class="dropdown-item disabled" href="#">' + 'twitter.shareon'._local() + ':</a><a target="_blank" class="dropdown-item" href="https://twitter.com/intent/retweet?tweet_id=' + tweet.id_str + '">Twitter</a><a target="_blank" class="dropdown-item" href="https://facebook.com/dialog/share?app_id=361037704438612&display=popup&href=' + encodeURIComponent('https://twitter.com/' + thisTweet.user.screen_name + '/' + tweet.id_str) + '">Facebook</a></div>');
            $shareWrapper.append($share);
            $shareWrapper.append($shareMenu);
            var $date = $('<div class="tweet-date">' + _time(thisTweet.created_at) + '</div>');

            $social.append($like);
            $social.append($shareWrapper);
            $footerInner.append($social);
            $footerInner.append($date);
            $footer.append($footerInner);

            $wrap.append($header);
            $wrap.append($body);

            if (!quoted)
                $wrap.append($footer);

            return $wrap;
        };

        var _getTimeline = function (target) {
            $.ajax({
                type: 'GET',
                dataType: 'json',
                url: 'https://s507swxaq6.execute-api.us-west-1.amazonaws.com/Prod/' + opts.screenName, // + '/' + opts.maxCount,
                //data: { screen_name: opts.screenName } //show retweets
                success: function (data /*, textStatus, XMLHttpRequest*/) {
                    var i;
                    //console.log(data);
                    for (i in data) {
                        if (i < opts.maxCount) {
                            target.append(_formatOneTweet(data[i], false));
                        }
                    }
                    target.find('[data-href]').on('click', function () {
                        window.open($(this).data('href'), '_blank');
                    });
                },
                error: function (req, status, /*error */) {
                    console.log('efw$twittertimeline: error: ' + status);
                }
            });

        };

        return this.each(function () {
            let $this = $(this);

            _getTimeline($this);
        });
    };

    $.fn.efw$twittertimeline.defaults = { screenName: '', maxCount: 3 };
})(jQuery);

